import { jsx } from "react/jsx-runtime";
import '../common/components/child-icon/child-icon.css';const ChildIcon = ({
  color = "white",
  strokeColor = "transparent",
  strokeWidth = 1,
  className = ""
}) => {
  const svgClassName = className ? `child-icon ${className}` : "child-icon";
  return /* @__PURE__ */ jsx(
    "svg",
    {
      className: svgClassName,
      preserveAspectRatio: "none",
      viewBox: "0 0 750 700",
      children: /* @__PURE__ */ jsx(
        "path",
        {
          d: "M388.5,304.5c-0.3,0.9-1.1,1.5-2.1,1.6c-26,0.6-50.6,12.2-67.7,31.8c0,0-2,2-7.2-2.1c-2.2-1.3-3.3-3.9-2.5-6.3 c7-17.7,25.2-29.4,53.9-34.7l0.8-0.1c5.9-0.8,19.6-2.7,24.2,6.5C388.6,302.2,388.8,303.4,388.5,304.5 M470.7,392.4l-0.2-0.2 c8.5-13.2,18.3-25.6,29.2-37c0.4-0.2,0.6-0.3,1-0.5c9.2-0.2,18.1-2.8,25.9-7.8c4.4-3.7,8.6-7.5,12.6-11.6c2.9-5,5.4-10.1,7.5-15.5v0 l-0.2,0.4l0.7-1.6l0.1-0.4l1.2-3.6c0-1.1-0.6-2-1.6-2.6c-0.8-0.3-1.6-0.4-2.4-0.3l0.1-0.2c0.6-1.1,1-2.4,1.1-3.7v-0.3 c-0.1-1.1-0.8-2.1-1.8-2.6c-1.2-0.5-2.5-0.6-3.7-0.2c-0.4-0.6-1-1.1-1.6-1.5c-0.3-0.2-1.9-0.8-5,1.1c-1.3,0.9-2.4,1.9-3.4,3.2 l0.2-1.9c-0.3-1-1.1-1.9-2.1-2.2c-1.7-0.5-3.6-0.1-5.1,1c-2.1,1.9-3.9,4.1-5.3,6.6c-1.9,1.5-3.5,3.4-4.7,5.4c-2.9,1.2-6.2,1.6-9.3,1 c2.5-1.3,4.7-2.9,6.7-4.9c2.6-2.8,4.2-6.4,4.6-10.3c0-0.5,0-1-0.1-1.5c-0.2-1.3-1-2.4-2.1-3c-3-1.5-6.5,1.5-7.2,2.1 c-0.1,0.1-1,1.1-1.6,1.7c-1.8,0.4-3.5,1.2-5,2.3c-1.2,0.9-2.5,1.5-3.9,1.9c-2.2,0.6-4.2,1.6-5.9,3l-0.2,0.1l0.1-0.1 c-0.4,0.3-3.6,2.4-4.6,3.1c-3.7,1.9-7,4.5-9.8,7.5c-11.6,10.7-25.9,18.1-41.3,21.4c-0.3-10.8-6.9-39.8-8.3-50.9 c-2.7-19.6-25.4-46.6-41.8-63.6c15.4,9,24,10.2,32.5-1.3c2.2-3.5,5.8,0.3,9-0.3c4.7-2.4,4.1-3.7,4.1-7.1c1.4-3.6,5-1.8,7.8-2.3 c6.9-1.1,2.8-8.3,5.5-12c30.2-1.8-3.9-29.5,16.5-41c10-5,18.4-12.7,24.1-22.3c4.9-6.6,5.9-1.4,9.5-6.8c4.2-25.9-2.9-52.4-19.4-72.9 c-74.9-96.3-160.4-51.9-185.4,7.7c-10.3,15.2-7.1,37.2-7.7,55.3c-1.9,6.3-5.7,6.1-11.2,2.4c-1.2,7.5,4,14.5,11.4,15.7 c0.5,0.1,0.9,0.1,1.4,0.1c0.5,1.6,3.3,4,4.5,5.7c-5,0.5-10.1-0.4-14.7-2.6c-0.3,2.8,0.6,5.6,2.5,7.7c1,7,6,12.7,12.8,14.7 c12,4.9,6.4,21.3,5,28.1c-0.4,1.5-0.9,3-1.3,4.4c-10.8,3.5-18.9,12.3-21.5,23.3c-1.4,25.3-14.4,46.3-14.2,72.4 c-0.1,1.8-0.1,3.6,0,5.4c6.5,28.3-1.8,65.4-0.4,94.6C164.5,408.3,77.9,437.8-1,482.6c119.4-46.8,246.7-70.4,375-69.6 c128.3-0.8,255.6,22.8,375,69.6C663.2,434.1,568.6,403.4,470.7,392.4",
          fill: color,
          stroke: strokeColor,
          strokeWidth
        }
      )
    }
  );
};
export {
  ChildIcon
};
//# sourceMappingURL=child-icon.js.map
